import axios from "axios";

const store = {
  state: {
    time_slot: [],
  },
  getters: {
    sameDayTimeSlot(state) {
      return state.same_day_time_slot.concat(payload["TWO_HOURS"], payload["FOUR_HOURS"], payload["EIGHT_HOURS"]);
    },
  },
  mutations: {
    INITIALIZE_TIMESLOT(state, payload) {
      state.time_slot = payload;
    },
  },
  actions: {},
};

export default store;
